import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      exibirFiltro: true,
      breadcrumbs: [],
    };
  },
  computed: {
    ...mapGetters('filtros', [
      'filtroLiquidacaoAcaoNivel3',
    ]),
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
  },
  watch: {
    filtroLiquidacaoAcaoNivel3(val) {
      if (val && this.breadcrumbs[2]) {
        this.breadcrumbs[2].text = this.montarTextoNivel3(val);
      }
    },
  },
  methods: {
    ...mapActions('filtros', [
      'setFiltroLiquidacaoAcaoNivel2',
      'setFiltroLiquidacaoAcaoNivel3',
    ]),
    iniciaBreadcrumbs() {
      if (this.breadcrumbs.length > 0) return;
      if (this.indModoVarejo) {
        this.breadcrumbs = [{
          text: this.$t('label.recebimento'),
          to: 'recebimento',
          disabled: true,
          nivel: 1,
        }];
      } else {
        this.breadcrumbs = [{
          text: this.$tc('label.pagamento', 1),
          to: 'pagamento',
          disabled: true,
          nivel: 1,
        }];
      }
    },
    navegarBreadcrumbs(item) {
      if (item.disabled) {
        return;
      }
      const visaoFornecedor = this.$router.currentRoute.name === 'nivel2Recebimento'
        || this.$router.currentRoute.name === 'detalharRecebimento'
        || this.$router.currentRoute.name === 'detalharPagamentoFornecedor';

      const visaoCliente = this.$router.currentRoute.name === 'nivel2PagamentoCliente'
        || this.$router.currentRoute.name === 'detalharPagamentoCliente';

      const visaoProjeto = this.$router.currentRoute.name === 'nivel2PagamentoProjeto'
        || this.$router.currentRoute.name === 'detalharPagamentoProjeto';

      let visao = 'Status';
      if (visaoCliente) {
        visao = 'Cliente';
      } else if (visaoFornecedor) {
        visao = 'Fornecedor';
      } else if (visaoProjeto) {
        visao = 'Projeto';
      }

      const params = {
        visao,
      };

      let query;

      if (item.status) {
        params.status = item.status;
      }

      if (item.idCliente) {
        params.idCliente = item.idCliente;
        query = { origem: item.text };
      }

      if (item.idFornecedor) {
        params.idFornecedor = item.idFornecedor;
        query = { origem: item.text };
      }

      if (item.idProjeto) {
        params.idProjeto = item.idProjeto;
        query = { origem: item.text };
      }

      this.$router.push({ name: item.to, params, query });
    },
    alteracaoRota(to) {
      this.iniciaBreadcrumbs();
      this.exibirFiltro = true;
      if (to.name === 'listarPagamentosNivel2Status') {
        this.adicionarItemBreadcrumbsStatus(to);
      } else if (to.name === 'nivel2PagamentoCliente') {
        this.adicionarItemBreadcrumbsCliente(to);
      } else if (to.name === 'nivel2PagamentoFornecedor') {
        this.adicionarItemBreadcrumbsFornecedor(to);
      } else if (to.name === 'nivel2Recebimento') {
        this.adicionarItemBreadcrumbsFornecedor(to);
      } else if (to.name === 'recebimento' || to.name === 'pagamento') {
        this.removerItemBreadcrumbs();
      } else if (to.name === 'nivel2PagamentoProjeto') {
        this.adicionarItemBreadcrumbsProjeto(to);
      } else {
        this.exibirFiltro = false;
        this.abrirFiltro = false;
        if (to.name === 'detalharPagamentoStatus') {
          this.adicionarItemBreadcrumbsDetalhesStatus(to);
        } else if (to.name === 'detalharPagamentoCliente') {
          this.adicionarItemBreadcrumbsDetalhesCliente(to);
        } else if (to.name === 'detalharPagamentoFornecedor') {
          this.adicionarItemBreadcrumbsDetalhesFornecedor(to);
        } else if (to.name === 'detalharRecebimento') {
          this.adicionarItemBreadcrumbsDetalhesFornecedor(to);
        } else if (to.name === 'detalharPagamentoProjeto') {
          this.adicionarItemBreadcrumbsDetalhesProjeto(to);
        }
      }
    },
    adicionarItemBreadcrumbsStatus(to) {
      this.breadcrumbs[0].disabled = false;

      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: this.$tc(`status_entidade_pagamento.${to.params.status.toLowerCase()}`, 1),
          status: to.params.status,
          to: to.name,
          disabled: true,
          nivel: 2,
        },
      ];
      this.setFiltroLiquidacaoAcaoNivel3(null);
    },
    adicionarItemBreadcrumbsFornecedor(to) {
      this.breadcrumbs[0].disabled = false;

      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: to.query.origem,
          idFornecedor: to.params.idFornecedor,
          to: to.name,
          disabled: true,
          nivel: 2,
        },
      ];
      this.setFiltroLiquidacaoAcaoNivel3(null);
    },
    adicionarItemBreadcrumbsCliente(to) {
      this.breadcrumbs[0].disabled = false;

      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: to.query.origem,
          idCliente: to.params.idCliente,
          to: to.name,
          disabled: true,
          nivel: 2,
        },
      ];
      this.setFiltroLiquidacaoAcaoNivel3(null);
    },
    adicionarItemBreadcrumbsDetalhesStatus(to) {
      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: this.$tc(`status_entidade.${to.params.status.toLowerCase()}`, 1),
          status: to.params.status,
          to: 'listarPagamentosNivel2Status',
          disabled: false,
          nivel: 2,
        },
        {
          text: this.montarTextoNivel3(to.params),
          to: to.name,
          disabled: true,
          nivel: 3,
        },
      ];
      this.breadcrumbs[0].disabled = false;
    },
    adicionarItemBreadcrumbsDetalhesCliente(to) {
      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: to.query.origem ? to.query.origem : this.breadcrumbs[1].text,
          idCliente: to.params.idCliente,
          to: 'nivel2PagamentoCliente',
          disabled: false,
          nivel: 2,
        },
        {
          text: this.montarTextoNivel3(to.params),
          to: to.name,
          disabled: true,
          nivel: 3,
        },
      ];
      this.breadcrumbs[0].disabled = false;
    },
    adicionarItemBreadcrumbsDetalhesFornecedor(to) {
      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: to.query.origem ? to.query.origem : this.breadcrumbs[1].text,
          idFornecedor: to.params.idFornecedor,
          to: 'nivel2Recebimento',
          disabled: false,
          nivel: 2,
        },
        {
          text: this.montarTextoNivel3(to.params),
          to: to.name,
          disabled: true,
          nivel: 3,
        },
      ];
      this.breadcrumbs[0].disabled = false;
    },
    adicionarItemBreadcrumbsProjeto(to) {
      this.breadcrumbs[0].disabled = false;

      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: to.query.origem,
          idProjeto: to.params.idProjeto,
          to: to.name,
          disabled: true,
          nivel: 2,
        },
      ];
      this.setFiltroLiquidacaoAcaoNivel3(null);
    },
    adicionarItemBreadcrumbsDetalhesProjeto(to) {
      this.breadcrumbs = [
        this.breadcrumbs[0],
        {
          text: to.query.origem ? to.query.origem : this.breadcrumbs[1].text,
          idProjeto: to.params.idProjeto,
          to: 'nivel2PagamentoProjeto',
          disabled: false,
          nivel: 2,
        },
        {
          text: this.montarTextoNivel3(to.params),
          to: to.name,
          disabled: true,
          nivel: 3,
        },
      ];
      this.breadcrumbs[0].disabled = false;
    },
    montarTextoNivel3(params) {
      let texto = '';
      if (params.idAcao) {
        texto = texto.concat(params.idAcao).concat(' - ');
      }
      if (params.codAcao) {
        texto = texto.concat(params.codAcao).concat(' - ');
      }
      if (params.cod_acao) {
        texto = texto.concat(params.cod_acao).concat(' - ');
      }
      if (params.codApuracao) {
        texto = texto.concat(params.codApuracao).concat(' - ');
      }
      if (params.cod_apuracao) {
        texto = texto.concat(params.cod_apuracao).concat(' - ');
      }
      if (params.codRecebimento) {
        texto = texto.concat(params.codRecebimento);
      }
      if (params.id) {
        texto = texto.concat(params.id);
      }
      return texto;
    },
    removerItemBreadcrumbs() {
      this.breadcrumbs[0].disabled = true;
      this.breadcrumbs = [this.breadcrumbs[0]];
      this.setFiltroLiquidacaoAcaoNivel2(null);
      this.setFiltroLiquidacaoAcaoNivel3(null);
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.alteracaoRota(to);
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.alteracaoRota(to);
    });
  },
};
